module.exports = __webpack_public_path__ + "assets/img/06b.3a09348c.jpg";